import {createContext} from 'react';

// Modal containers are controlled outside of react
const ModalContainer = createContext(null);
ModalContainer.displayName = 'ModalContainer';

export default ModalContainer;
